/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// React
import React from 'react';
// redux hooks
import { useFieldArray, Controller } from 'react-hook-form';
// BASE components
import BASESvgIcon from '../../../@BASE/core/BASESvgIcon';
// material-ui components
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/system/Box';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import Typography from '@mui/material/Typography';
import { Icon } from '@mui/material';

export default function IDArray({
  control,
  register,
  setValue,
  getValues,
  errors,
  label,
}) {
  // setup field array
  const { fields, append, remove, move } = useFieldArray({
    control,
    name: 'linked_lesson_list',
  });

  return (
    <>
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0
          }
        }}
        className="px-0"
      >
        {fields.map((item, index) => {
          return (
            <TimelineItem key={item.id}>
              <TimelineSeparator>
                <TimelineDot color="secondary" sx={{ marginTop: '22px' }} />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent className="py-0">
                <div className='flex items-center justify-between'>
                  <Controller
                    control={control}
                    name={`linked_lesson_list.${index}`}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="mt-16 mb-16"
                        label={`${label} ID`}
                        placeholder={`${label} ID`}
                        error={
                          !!errors.content?.linked_lesson_list?.[index]
                        }
                        helperText={
                          errors.content?.linked_lesson_list?.[index]
                            ?.message
                        }
                        fullWidth
                        required
                        size='small'
                      />
                    )}
                  />
                  {index !== 0 && (
                    <IconButton
                      onClick={() => move(index, index - 1)}
                      size="small"
                    >
                      <BASESvgIcon size={20}>
                        heroicons-solid:arrow-circle-up
                      </BASESvgIcon>
                    </IconButton>
                    // <Button
                    //   variant="outlined"
                    //   onClick={() => move(index, index - 1)}
                    //   startIcon={
                    //     <BASESvgIcon size={20}>
                    //       heroicons-solid:arrow-circle-up
                    //     </BASESvgIcon>
                    //   }
                    //   size="small"
                    // />
                  )}
                  {index !== fields.length - 1 && (
                    <IconButton
                      onClick={() => move(index, index + 1)}
                      size="small"
                    >
                      <BASESvgIcon size={20}>
                        heroicons-solid:arrow-circle-down
                      </BASESvgIcon>
                    </IconButton>
                    // <Button
                    //   variant="outlined"
                    //   onClick={() => move(index, index + 1)}
                    //   startIcon={
                    //     <BASESvgIcon size={20}>
                    //       heroicons-solid:arrow-circle-down
                    //     </BASESvgIcon>
                    //   }
                    //   size="small"
                    // />
                  )}
                  <IconButton
                    onClick={() => remove(index)}
                    size="small"
                    color="error"
                  >
                    <BASESvgIcon size={20}>
                      heroicons-outline:trash
                    </BASESvgIcon>
                  </IconButton>
                  {/* <Button
                    variant="contained"
                    onClick={() => remove(index)}
                    color="error"
                    startIcon={
                      <BASESvgIcon size={20}>
                        heroicons-outline:trash
                      </BASESvgIcon>
                    }
                    size="small"
                  /> */}
                </div>
              </TimelineContent>
            </TimelineItem>
          );
        })}
      </Timeline>
      <Box className="flex items-center mt-0 p-0">
        <Button
          className="group flex items-center mt-8 rounded cursor-pointer"
          color="secondary"
          variant="contained"
          onClick={() =>
            append('')
          }
        >
          <BASESvgIcon size={20}>heroicons-solid:plus-circle</BASESvgIcon>
          <span className="ml-8 font-medium text-secondary group-hover:underline">
            Add {label}
          </span>
        </Button>
      </Box>
    </>
  );
}
